export const SW_MESSAGE_TIMEOUT_MS = 500
export const SW_MSG_GET_CACHED_QUERIES = 'GET_CACHED_QUERIES' as const
export const SW_MSG_CACHED_QUERIES_RESPONSE = 'CACHED_QUERIES_RESPONSE' as const
export const SW_POST_REQUEST_EVENT = 'service_worker.postrequest'
